import { USER_SERVICE } from "../consts";

export const LOCATION_API = `${USER_SERVICE}locations`;
